import { takeLatest, put, select, call } from 'redux-saga/effects';

import { SELECT_DEALER } from 'constants/ActionTypes';
import { AUDIT_MODEL, ASSIGNEE_USER_GROUPS } from 'constants/FilterConstants';
import { PATH } from 'constants/RoutesConstants';
import { scopeToPage } from 'modules/app/sagas/utils';
import * as dashboardActions from 'modules/audits/actions/dashboard';
import * as actionTypes from 'modules/audits/actionTypes';
import { DASHBOARD_SOURCE } from 'modules/audits/constants';
import { getBaseRequestParams } from 'modules/audits/selectors/dashboard';
import { getUserGroups } from 'modules/userGroups/actions';
import { getSelectedDealerId } from 'selectors/dealerSelectors';

function* afterSetFilters() {
  const dealerId = yield select(getSelectedDealerId);
  yield put(getUserGroups(dealerId));

  const meta = { source: DASHBOARD_SOURCE, reset: true };
  const params = yield select(getBaseRequestParams);
  yield put(dashboardActions.fetchAudits(params, meta));
}

function* handleFilterChange() {
  const params = yield select(getBaseRequestParams);
  yield put(dashboardActions.fetchAudits({ ...params, page: 0 }, { source: DASHBOARD_SOURCE }));
}

function* afterChangeDealer() {
  const dealerId = yield select(getSelectedDealerId);
  yield put(getUserGroups(dealerId));
  yield put(dashboardActions.setDashboardFilters(
    [
      { field: AUDIT_MODEL, value: [] },
      { field: ASSIGNEE_USER_GROUPS, value: [] },
    ],
    { reset: true, source: DASHBOARD_SOURCE }
  ));
}

function* onPageWorker() {
  yield call(afterSetFilters);
  yield takeLatest(SELECT_DEALER, afterChangeDealer);

  yield takeLatest([
    actionTypes.SET_AUDITS_DASHBOARD_FILTER,
    actionTypes.SET_AUDITS_DASHBOARD_FILTERS,
    actionTypes.REMOVE_AUDITS_DASHBOARD_FILTER,
    actionTypes.CLEAR_AUDITS_DASHBOARD_FILTERS,
  ], handleFilterChange);
}

export default function* auditSagas() {
  yield scopeToPage([PATH.AUDITS], onPageWorker);
}
